module.exports = __webpack_public_path__ + "img/bg4.3f71073d.jpg";